/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_Body_FieldInputs */

const cs_builder_block_body_field = /** @type {(inputs: Builder_Block_Body_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tělo / dlouhý text`)
};

const en_builder_block_body_field = /** @type {(inputs: Builder_Block_Body_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body / long text field`)
};

/**
* | output |
* | --- |
* | "Body / long text field" |
*
* @param {Builder_Block_Body_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_body_field = /** @type {((inputs?: Builder_Block_Body_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_Body_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_body_field(inputs)
	return cs_builder_block_body_field(inputs)
});